import { useMemo } from 'react';
import { CPRWSData } from '../interfaces';

export const useCPRWSData = (): CPRWSData | null => {
  return useMemo(() => {
    const query = new URLSearchParams(window.location.search);
    const cprwsParam = query.get('cprws');
    if (!cprwsParam) return null;

    try {
      return JSON.parse(cprwsParam) as CPRWSData;
    } catch {
      console.warn('Invalid cprws parameter');
      return null;
    }
  }, []);
};
